const header = ()=>import("@/components/HEAD.vue"); // 首页
const aside = ()=>import("@/components/ASIDE.vue"); // 集团门户 - 会员中心内嵌页面 左侧菜单
const sideMenu = ()=>import("@core/components/LEFT.vue");

const navigation = ()=>import("../views/navigation/navigation.vue");

export default[
    {
      path: "/inforMan",
      name: "inforMan",
      redirect: {
        name: "columnList"
      }
    },

    {
      // 信息管理
      path: "/messageList",
      name: "navigation",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: navigation
      },
      meta: {
        root: "/"
      }
    }
  ]



// WEBPACK FOOTER //
// ./src/router/inforMan.js